import { Button, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <Stack spacing={2}>
      <div>
        <Typography variant="h1">{t('notFound.title')}</Typography>
      </div>
      <div>
        <Button component={Link} variant="contained" color="primary" to="/">
          {t('notFound.backButton')}
        </Button>
      </div>
    </Stack>
  );
}
